
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getSchedule} from 'sr/utils/api/masterData/schedule/getSchedule'
export const fetchschedule = createAsyncThunk(
  'getSchedule',
  async () => {
    const response = await getSchedule()
    return response?.data
  }
)


